module.exports = __webpack_public_path__ + "img/1.5-人工.d50868ab.svg";